module.exports = __webpack_public_path__ + "public/images/stands-logo-2@2x.04cd0406a88e576ac7fe0556329d87e2.webp";